import { CompositeView, LayoutView } from 'backbone.marionette';
import _ from 'underscore';

import Page from '../../../base/collections/page';
import BankAccount from '../../../transactions/collections/account';


const OptionView = LayoutView.extend({
  tagName: 'option',

  template: require('../../templates/bankaccount/option.html'),

  attributes() {
    const model = this.model;

    return {
      selected: (model.id || null) == this.getOption('settlement_account'),
      value: model.id || ''
    };
  },

  templateHelpers() {
    const model = this.model;
    return {
      unset: model.get('id') ? false : true
    };
  }
});


const BankView = CompositeView.extend({
  childView: OptionView,
  childViewContainer: 'select',

  tagName: 'tr',
  template: require('../../templates/bankaccount/row.html'),

  ui: {
    settlement: 'select',
    selected: 'option:selected'
  },

  triggers: {
    'change @ui.settlement': 'change:settlement'
  },

  modelEvents: {
    'change:fm_bank': 'render'
  },

  childViewOptions() {
    const settlement_account = this.model.get('fm_bank');
    return {
      settlement_account
    };
  },
  templateHelpers() {
    const payment_items = this.model.get('payment_items');

    const sliced = _.map(_.range(5), index => payment_items[index] || '');

    return {
      sliced_payment_items: sliced
    };
  },

  /** Set the model value to the newly selected option. We must do it here
  *   because option doesn't support the 'click' event in WebKit.
  */
  onChangeSettlement() {
    const selected_option = this.ui.settlement;
    this.model.set({
      fm_bank: selected_option.val(),
      bank_account: this.model.get('id')
    });
  }
});


const TableView = CompositeView.extend({
  childView: BankView,
  childViewContainer: 'tbody',

  childViewOptions(model, index) {
    return {
      className: index % 2 ? '' : 'alt',
      collection: this.options.settlement
    };
  },

  tagName: 'table',
  className: 'datatable',

  template: require('../../templates/bankaccount/table.html')
});


export const BankLayoutView = LayoutView.extend({
  template: require('../../templates/bankaccount/layout.html'),

  collectionEvents: {
    request: 'displayMessage'
  },

  regions: {
    table: '.table-hook'
  },

  ui: {
    save: '.map'
  },

  events: {
    'click @ui.save': 'save'
  },

  initialize(options) {
    this.collection = new Page([], { urlBase: options.bankaccount_url });
    this.collection.fetch();
  },

  onRender() {
    const settlement = new BankAccount(
      [], { urlBase: this.options.settlement_url });

    settlement.fetch({
      success(collection) {
        collection.add({}, { at: 0 });
      }
    });

    const tableView = new TableView({
      collection: this.collection,
      settlement
    });

    this.showChildView('table', tableView);
  },

  save() {
    this.collection.sync(
      'create', this.collection, { url: this.collection.url() }
    );
  },

  templateHelpers() {
    return {
      disabled: this.getOption('is_staff') ? '' : 'disabled'
    };
  },

  displayMessage() {
    window.messages.add(`${this.collection.length} accounts mapped`);
  }
});



// WEBPACK FOOTER //
// ./parentpay/views/bankaccount/index.js